<template>
    <div class="relative bg-white mobile:!rounded-md largeDesktop:!rounded-lg text-left w-full overflow-hidden border border-gray-600"
        ref="marqueeContainer" @click="handleContainerClick">
        <!-- class="autocomplete-input pl-2 py-3 pr-10 text-xl 2xl:text-2xl 2xl:pl-2 2xl:py-3 rounded-xl min-w-full text-left focus:outline-none" -->
        <!-- Hidden fake input to trick browser -->
        <input type="text" style="position: absolute; top: -9999px; left: -9999px; opacity: 0;" tabindex="-1" autocomplete="nope" />
        <input ref="autocompleteInput" :class="['autocomplete-input', inputClass]" type="text"
            :placeholder="placeholder" v-model="address" @focus="handleFocus" @blur="handleBlur" @input="handleInput"
            :readonly="isReadonly"
            autocomplete="nope" aria-autocomplete="none" autocorrect="off" autocapitalize="off" spellcheck="false" data-form-type="other" data-lpignore="true" />
        <div class="marquee-text absolute left-4 top-1/2  py-1 whitespace-nowrap pointer-events-auto bg-customTransparent"
            ref="marqueeText" :class="{ 'marquee-active': shouldAnimate }" @click.stop="focusInput">
            {{ address }}
        </div>
    </div>
</template>

<script>
export default {
    name: "GoogleAutocomplete",
    props: {
        placeholder: {
            type: String,
            default: "Address",
        },
        modelValue: {
            type: String,
            default: ""
        },
        reset: {

        },
        inputClass: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue', 'place-selected', 'address-reset'],
    data() {
        return {
            autocomplete: null,
            isManualEdit: false,
            address: '',
            shouldAnimate: false,
            isInputFocused: false,
            isReadonly: true
        };
    },
    watch: {
        modelValue(newVal) {
            this.address = newVal;
            this.$nextTick(this.checkForAnimation);
        },

        reset(newVal) {
            const inputElement = this.$refs.autocompleteInput;
            inputElement.style.opacity = '1';
            this.address = ''
        }
    },
    mounted() {
        this.initAutocomplete();
        this.checkForAnimation();
        window.addEventListener('resize', this.checkForAnimation);
        window.addEventListener('scroll', this.handleScroll, true);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkForAnimation);
        window.removeEventListener('scroll', this.handleScroll, true);
    },
    methods: {
        handleScroll() {
            if (this.isInputFocused) {
                const pacContainers = document.querySelectorAll('.pac-container');
                pacContainers.forEach(container => {
                    container.style.display = 'none';
                });
            }
        },
        initAutocomplete() {
            if (!window.google) {
                console.error("Google Maps JS API is not loaded!");
                return;
            }

            this.autocomplete = new window.google.maps.places.Autocomplete(
                this.$refs.autocompleteInput,
                {
                    types: ["geocode"],
                    componentRestrictions: { country: "us" } // restrict to USA
                }
            );

            this.autocomplete.addListener("place_changed", this.onPlaceChanged);
        },
        onPlaceChanged() {
            const place = this.autocomplete.getPlace();
            if (place && place.formatted_address) {
                this.address = place.formatted_address;
                this.isManualEdit = false;
                this.$emit("place-selected", place);
                this.$emit('update:modelValue', this.address);
                this.checkForAnimation();
            }
        },
        handleFocus() {
            this.isReadonly = false;
            this.isInputFocused = true;
            this.checkForAnimation();
        },
        handleBlur() {
            this.isInputFocused = false;
            this.checkForAnimation();
        },
        handleInput(event) {
            if (!this.isManualEdit) {
                this.isManualEdit = true;
                this.$emit("address-reset");
            }
            this.$emit('update:modelValue', event.target.value);
            this.checkForAnimation();
        },
        focusInput() {
            this.$refs.autocompleteInput.focus();
        },
        handleContainerClick() {
            if (this.shouldAnimate && !this.isInputFocused) {
                this.focusInput();
            }
        },
        checkForAnimation() {
            this.$nextTick(() => {
                const container = this.$refs.marqueeContainer;
                const textElement = this.$refs.marqueeText;
                const inputElement = this.$refs.autocompleteInput;

                if (!container || !textElement || !inputElement) return;

                // Create temporary span to measure text width
                const tempSpan = document.createElement('span');
                tempSpan.style.visibility = 'hidden';
                tempSpan.style.whiteSpace = 'nowrap';
                tempSpan.style.position = 'absolute';
                tempSpan.style.fontSize = window.getComputedStyle(textElement).fontSize;
                tempSpan.style.fontFamily = window.getComputedStyle(textElement).fontFamily;
                tempSpan.style.padding = '0 15px';
                tempSpan.textContent = this.address || '';
                document.body.appendChild(tempSpan);

                const textWidth = tempSpan.offsetWidth;
                const containerWidth = container.clientWidth - 40; // Adjust for padding

                document.body.removeChild(tempSpan);

                this.shouldAnimate = textWidth > containerWidth && this.address && this.address.length > 0 && !this.isInputFocused;

                if (this.shouldAnimate) {
                    inputElement.style.opacity = '0';
                    textElement.style.display = 'flex';
                    textElement.style.cursor = 'text';
                } else {
                    inputElement.style.opacity = '1';
                    textElement.style.display = 'none';
                }
            });
        }
    }
};
</script>

<style>
.marquee-text {
    transform: translateY(-50%);
    display: none;
    color: #585858;
}

.marquee-text.marquee-active {
    display: flex;
    animation: marquee 10s linear infinite;
    padding-left: 100%;
}

.pac-container { 
    z-index: 99999 !important;
}

@keyframes marquee {
    0% {
        transform: translateY(-50%) translateX(0);
    }

    100% {
        transform: translateY(-50%) translateX(-100%);
    }
}

/* .autocomplete-input {
    background-color: transparent;
    border: none;
    width: 100%;
} */
</style>
